import {
  PrimitiveValueType,
  RowDataReducerState,
  RowDataReducerAction,
  ErrorState,
} from "../../../../../types";
import { noError } from "../../../validations";

export const validateWriteOffMaxDebitandMaxCredit = (
  propertyKey: string,
  inputValue: PrimitiveValueType | undefined,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): ErrorState | void => {
  const writeOffAmountFields = ["max_debit", "max_credit"];

  if (!writeOffAmountFields.includes(propertyKey)) return;
  if (rowDataReducerState.rowData["scheduled_acct"] === "") return;

  const counterpartFieldKey = writeOffAmountFields.find(
    (key) => key !== propertyKey,
  )!;

  const fieldValidation =
    inputValue === 0 && rowDataReducerState.rowData[counterpartFieldKey] === 0
      ? {
          error: true,
          message:
            "At least one of Maximum debit or Maximum Credit must be non-zero,adjust the values accordingly",
        }
      : noError();

  writeOffAmountFields.forEach((field) => {
    dispatch({
      type: "UPDATE_FIELD_VALIDATION",
      payload: {
        propertyKey: field,
        newFieldValueValidation: fieldValidation,
      },
    });
  });

  return fieldValidation;
};
